import React from 'react';
import styled from 'styled-components';
import { Flex, Typography } from '@slope/uikit';

const LoadingSpinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export interface LoadingStateProps {
  message?: string;
}

export const LoadingState: React.FC<LoadingStateProps> = ({
  message = 'Cargando clubes de golf...',
}) => {
  return (
    <Flex
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: '50vh' }}
    >
      <LoadingSpinner />
      <Typography fontSize="18px" fontWeight="600" mt="1rem">
        {message}
      </Typography>
    </Flex>
  );
};
